import { SET_GUIDE_TAG, CLEAR_GUIDE_TAGS, IMPORT_STATE } from "../common/actions";

export default function guideTagValues(state = {}, action = {}) {
  switch (action.type) {
    case SET_GUIDE_TAG: {
      const { tag, value } = action.payload || {};
      if (!tag) return state;
      return { ...state, [tag]: value };
    }
    case CLEAR_GUIDE_TAGS:
      return {};
    case IMPORT_STATE:
      // tagValues are runtime-only; do not restore from import payload.
      return {};
    default:
      return state;
  }
}
